export const DashboardPage = () => <h2>🏠 Приватная страница</h2>